module.exports = __webpack_public_path__ + "img/search.ff350f83.svg";